import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const Navbar = ({ icon, cart, title }) => {
  return (
    <div className='navbar p-0'>
      <h2 className='text-light'>{title}</h2>
      <div className='navbar_links '>
        <ul className=''>
          <li className='dropdown'>
            <NavLink
              activeClassName='active '
              className='nav_link'
              to='/apparel'
            >
              Collections <i className={icon} aria-hidden='true'></i>
            </NavLink>
            <div className='dropdown-content'>
              {/* <a href='#'>Collection 1</a>
              <a href='#'>Collection 2</a>
              <a href='#'>Collection 3</a>
              <a href='#'>Collection 4</a> */}
            </div>
          </li>
          <li>
            <NavLink activeClassName='active' to='/hoodies'>
              Hoodies
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName='active' to='/masks'>
              Masks
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName='active' to='/tees'>
              Tees
            </NavLink>
          </li>
        </ul>
        <div className='navbar-icons'>
          <NavLink activeClassName='active' to='/login'>
            <i className='fa fa-user' aria-hidden='true'></i>
          </NavLink>
          <NavLink activeClassName='active' to='/cart'>
            <i className={cart} aria-hidden='true'></i>
          </NavLink>
        </div>
      </div>
    </div>
  );
};
Navbar.defaultProps = {
  title: 'Apparel',
  icon: 'fa fa-chevron-down',
  cart: 'fa fa-shopping-cart',
};

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  cart: PropTypes.string.isRequired,
};

export default Navbar;
